import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CompanyLayout from '../../components/company/CompanyLayout';
import CompanyOverview from './CompanyOverview';
import CamerasPage from './CamerasPage';
import TimelapsePage from './TimelapsePage';

const CompanyDashboard = () => {
  return (
    <CompanyLayout>
      <Routes>
        <Route path="/" element={<CompanyOverview />} />
        <Route path="/cameras" element={<CamerasPage />} />
        <Route path="/timelapse" element={<TimelapsePage />} />
        <Route path="*" element={<Navigate to="/company" replace />} />
      </Routes>
    </CompanyLayout>
  );
};

export default CompanyDashboard;
